document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('[data-fbt-wrapper]');
  if (!wrapper) return;

  var checkboxes = wrapper.querySelectorAll('.fbt-checkbox');
  var totalNowEl = wrapper.querySelector('[data-fbt-total-now]');
  var totalWasEl = wrapper.querySelector('[data-fbt-total-was]');
  var addBtn = wrapper.querySelector('[data-fbt-add-btn]');
  var errorEl = wrapper.querySelector('[data-fbt-error]');

  // Shopify money format: prices come from Liquid as integer cents.
  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && window.moneyFormat) {
      return Shopify.formatMoney(cents, window.moneyFormat);
    }
    return (cents / 100).toLocaleString('pt-PT', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  function recalcTotal() {
    var totalNow = 0;
    var totalWas = 0;
    var anyChecked = false;

    checkboxes.forEach(function (cb) {
      if (cb.checked) {
        anyChecked = true;
        var price = parseInt(cb.dataset.price, 10) || 0;
        var comparePrice = parseInt(cb.dataset.comparePrice, 10) || 0;
        totalNow += price;
        totalWas += comparePrice > price ? comparePrice : price;
      }
    });

    totalNowEl.textContent = formatMoney(totalNow);
    totalWasEl.textContent = totalWas > totalNow ? formatMoney(totalWas) : '';
    addBtn.disabled = !anyChecked;
  }

  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', recalcTotal);
  });

  addBtn.addEventListener('click', function () {
    var items = [];
    checkboxes.forEach(function (cb) {
      if (cb.checked) {
        items.push({
          id: parseInt(cb.dataset.variantId, 10),
          quantity: 1
        });
      }
    });

    if (items.length === 0) return;

    errorEl.hidden = true;
    addBtn.disabled = true;
    addBtn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || 'Erro ao adicionar ao carrinho.');
          });
        }
        return res.json();
      })
      .then(function () {
        // Fica na mesma página e abre o drawer, em vez de ir para /cart.
        // Reutiliza o mesmo mecanismo "open_cart=1" do cart-drawer.liquid.
        var currentPath = window.location.pathname + window.location.search;
        var separator = currentPath.indexOf('?') > -1 ? '&' : '?';
        window.location.href = currentPath + separator + 'open_cart=1';
      })
      .catch(function (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
        addBtn.disabled = false;
        addBtn.textContent = addBtn.getAttribute('data-original-label') || 'Aproveitar combo';
      });
  });

  addBtn.setAttribute('data-original-label', addBtn.textContent.trim());
  recalcTotal();
});